/* eslint-env browser, jquery */
/* global WOW */
import container from 'modules/section-content';
import rg from 'modules/npm-component/require-global';
import domify from 'domify';
import Batch from 'batch';
import page from 'modules/ab-page-js';
import request from 'superagent';
import splash from './jobs-page.pug';
import culture from './culture.json';
import metadata from './metadata.json';

let pollTimer = 0;
let numberOfLogins = 0;

export default function register() {
  const loadJobsMiddleware = callOnceMiddleware.bind(null, loadJobs);
  const renderMiddleware = callOnceMiddleware.bind(null, render);
  const loadScriptsMiddleware = callOnceMiddleware.bind(null, loadScripts);
  const commonMiddleware = callOnceMiddleware.bind(null, common);

  page(
    '/jobs',
    loadJobsMiddleware,
    renderMiddleware,
    loadScriptsMiddleware,
    commonMiddleware,
    clearSelections
  );
  page(
    '/jobs/:department',
    loadJobsMiddleware,
    renderMiddleware,
    loadScriptsMiddleware,
    commonMiddleware,
    clearSelections,
    showDepartment
  );
  page(
    '/jobs/:department/:opening',
    loadJobsMiddleware,
    renderMiddleware,
    loadScriptsMiddleware,
    commonMiddleware,
    clearSelections,
    showOpening
  );
  page('*', (ctx, next) => {
    if (window.location.pathname.indexOf('/jobs') !== 0) {
      resetCallOnceScorecard();
    }
    return next();
  });

  page.exit('/jobs/(.*)?', unpoll);
}

function loadJobs(ctx, next) {
  ctx.jobs = [];
  request.get('/jobs.json').end((err, res) => {
    if (err || !res || !res.body || !res.body.length) {
      return next();
    }

    ctx.jobs = res.body;
    return next();
  });

  return null;
}

function render(ctx, next) {
  $('html').removeClass('header-dark');
  const view = domify(splash({ jobs: ctx.jobs, culture }));
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view })
  };
  container.render(renderOptions);

  return next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/jobs/resources/owl-ffaa3c82ad.carousel.min.js', '$.fn.owlCarousel', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/jobs/resources/jquery-78b16ff121.accordion.js', '$.fn.accordion', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/jobs/resources/jquery-0850ae304b.mixitup.min.js', '$.MixItUp', done);
  });

  batch.push(done => {
    rg('//maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js', 'bootstrap', done);
  });

  batch.end(next);
}

function common(ctx, next) {
  $('#owl-banner').owlCarousel({
    items: 1,
    responsiveRefreshRate: 10,
    nav: true,
    mouseDrag: false,
    lazyLoad: true
  });

  $('#owl-who').owlCarousel({
    items: 1,
    responsiveRefreshRate: 10,
    nav: false,
    mouseDrag: false,
    lazyLoad: true
  });

  $('#owl-culture').owlCarousel({
    center: true,
    loop: true,
    lazyLoad: true,
    responsiveRefreshRate: 10,
    mouseDrag: false,
    nav: true,
    dots: false,
    navText: '',
    items: 2
  });

  $('.modal').on('hidden.bs.modal', () => {
    const { department, opening } = getLocationParams();
    if (!opening) {
      return null;
    }

    const activeFilter = $('.jobs__items').mixItUp('getState').activeFilter;
    if (activeFilter === '.mix') {
      return page('/jobs');
    }

    return page(`/jobs/${department}`);
  });

  $('.jobs__items').mixItUp({
    layout: {
      display: 'flex'
    },
    callbacks: {
      onMixStart(state, futureState) {
        const { opening } = getLocationParams();
        const activeFilter = (futureState.activeFilter || '').substr(1);

        if (futureState.activeFilter === state.activeFilter) {
          return null;
        }

        if (opening) {
          return null;
        }

        if (activeFilter === 'mix') {
          return page('/jobs');
        }

        return page(`/jobs/${activeFilter}`);
      }
    }
  });

  updateNumberOfLogins(poll);
  new WOW().init();

  // HACK: we need to apply this style after mixItUp is called otherwise job positions
  // will be hidden until mixItUp loads
  const styleSheet = document.getElementById('jobs__item_style');
  if (styleSheet) {
    styleSheet.sheet.insertRule('.jobs-page .jobs__item { display: none; }', 0);
  }

  next();
}

function clearSelections(ctx, next) {
  const { department, opening } = getLocationParams();
  if (!department) {
    $('.jobs__items').mixItUp('filter', '.mix');
  }

  if (!opening) {
    $('.modal.active button[data-dismiss="modal"]').click();

    setTitle();
    setDescription();
  }

  return next();
}

function showDepartment(ctx, next) {
  const { department } = getLocationParams();
  $('.jobs__items').mixItUp('filter', `.${department}`);

  return next();
}

function showOpening(ctx, next) {
  const { opening } = getLocationParams();
  $('nav.menu-bar a').removeClass('active');
  $(`[href="/jobs/${opening}"]`).addClass('active');
  $('.tab-content .tab-pane').removeClass('active');
  $(`[id="${opening}"]`).addClass('active');

  const title = $(`#${opening} h4`).text();

  setTitle(title);
  setDescription(title);

  $(`#${opening}`).modal('show');

  next();
}

function setTitle(text) {
  const suffix = text || 'Auth0';
  document.title = `Jobs - ${suffix}`;
}

function setDescription(text) {
  const prefix = text || 'jobs';
  const $description = $('meta[name=description]');
  $description.attr(
    'content',
    `${prefix}. We are always looking for talented people to join our team.`
  );
}

function updateNumberOfLogins(callback) {
  $.ajax({
    url: '/jobs/counters',
    cache: false
  }).done(response => {
    numberOfLogins = response.logins;
    $('.js-join-stats').toggleClass('join-hidden', false);
    $('.js-join-stats').toggleClass('animated fadeInDown', true);

    $('#tokens').text(numberOfLogins.toLocaleString());

    if (typeof callback === 'function') callback();
  });
}

function unpoll(ctx, next) {
  clearTimeout(pollTimer);
  const modalCloseButton = document.querySelector('.close');
  if (modalCloseButton) {
    modalCloseButton.click();
  }
  return next();
}

function poll() {
  pollTimer = setTimeout(updateNumberOfLogins, 1000, poll);
}

function getLocationParams() {
  const pathname = window.location.pathname;
  const parts = pathname.split('/').filter(part => part);
  if (parts.length === 3) {
    return { isRoot: false, department: parts[1], opening: parts[2] };
  }

  if (parts.length === 2) {
    return { isRoot: false, department: parts[1], opening: '' };
  }

  return { isRoot: true, department: '', opening: '' };
}

const callOnceScorecard = {};
function callOnceMiddleware(fn, ctx, next) {
  if (callOnceScorecard[fn.name]) {
    return next();
  }

  callOnceScorecard[fn.name] = true;
  return fn(ctx, next);
}

function resetCallOnceScorecard() {
  Object.keys(callOnceScorecard).forEach(key => (callOnceScorecard[key] = false));
}



// WEBPACK FOOTER //
// ./src/pages/jobs/jobs.js